// extracted by mini-css-extract-plugin
export var active = "_1m-7";
export var container = "_1m-0";
export var evenWidth = "_1m-4";
export var large = "_1m-5";
export var outlet = "_1m-8";
export var slide = "_1m-2";
export var small = "_1m-6";
export var tab = "_1m-3";
export var tabs = "_1m-1";